import { Badge, CloseButton, Group, Text } from "@mantine/core";
import { AiSparkButton } from "./AiSparkButton";
import type { ActiveFilter } from "./services/describeActiveFilters";

export const ActiveFiltersBar = ({
    filters,
    onRemove,
    onAskAi,
}: {
    filters: ActiveFilter[];
    onRemove: (id: string) => void;
    onAskAi: () => void;
}) => {
    if (filters.length === 0) return null;

    return (
        <Group
            gap="xs"
            wrap="wrap"
            px="md"
            py="xs"
            style={{
                background: "#faf8ff",
                border: "1px solid #ece5fb",
                borderRadius: 10,
            }}
        >
            <Text size="sm" fw={600} c="dimmed">
                Filters
            </Text>
            {filters.map((filter) => (
                <Badge
                    key={filter.id}
                    variant="light"
                    color="violet"
                    size="lg"
                    tt="none"
                    rightSection={
                        <CloseButton
                            size="xs"
                            aria-label={`Remove ${filter.label} filter`}
                            onClick={() => onRemove(filter.id)}
                        />
                    }
                >
                    {filter.label}: {filter.value}
                </Badge>
            ))}
            <Group ml="auto">
                <AiSparkButton onClick={onAskAi} />
            </Group>
        </Group>
    );
};
